module.exports = __webpack_public_path__ + "static/AngelaHe12-32ea77a53c295adc8c71f8fa7532be36.webp";